import React from "react"
import DesktopProductImages from "./DesktopProductImages"
import MobileProductImages from "./MobileProductImages"

export type MuxVideo = {
  title: string
  video: {
    ratio: string
    ready: boolean
    assetId: string
    version: number
    duration: number
    audioOnly: boolean
    created_at: number
    playbackId: string
    max_stored_frame_rate: number
    max_stored_resolution: string
  }
}

interface ProductImagesProps {
  currentVariant: {
    images: Array<string>
  }
  images: Array<string>
  lifestyleMuxVideos?: Array<MuxVideo>
  imageGalleryMuxVideos?: Array<MuxVideo>
}

const ProductImages = (props: ProductImagesProps) => (
  <>
    <DesktopProductImages {...props} />
    <MobileProductImages {...props} />
  </>
)

export default ProductImages
